import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './pages/home/home.component';
import { AboutComponent } from './pages/about/about.component';
import { ContactComponent } from './pages/contact/contact.component';
import { VaccancyComponent } from './pages/vaccancy/vaccancy.component';
import { JuniorconsultantComponent } from './pages/juniorconsultant/juniorconsultant.component';
import { LoginComponent } from './pages/login/login.component';
import { RegisterComponent } from './pages/register/register.component';
import { SeniorconsultComponent } from './pages/seniorconsult/seniorconsult.component';
import { IisconsultComponent } from './pages/iisconsult/iisconsult.component';
import { ConsultsankalpComponent } from './pages/consultsankalp/consultsankalp.component';
import { AssociatesankalpComponent } from './pages/associatesankalp/associatesankalp.component';
import { PmuComponent } from './pages/pmu/pmu.component';
import { OtrformComponent } from './pages/otrform/otrform.component';
import { TestRegComponent } from './pages/test-reg/test-reg.component';
import { TestotrComponent } from './pages/testotr/testotr.component';
import { TestloginComponent } from './pages/testlogin/testlogin.component';
import { TestdashboardComponent } from './pages/testdashboard/testdashboard.component';
import { AuthenticationGuard } from './api/authentication.guard';
import { TesteditregComponent } from './pages/testeditreg/testeditreg.component';
import { ContentwriterComponent } from './pages/contentwriter/contentwriter.component';
import { EngagingconultComponent } from './pages/engagingconult/engagingconult.component';
import { EngagingtechComponent } from './pages/engagingtech/engagingtech.component';
import { VocationalComponent } from './pages/vocational/vocational.component';
import { PrgrmmanagerComponent } from './pages/prgrmmanager/prgrmmanager.component';
import { FtcseniorComponent } from './pages/ftcsenior/ftcsenior.component';
import { FtccounsellerComponent } from './pages/ftccounseller/ftccounseller.component';
import { FtclegalComponent } from './pages/ftclegal/ftclegal.component';
import { FtcconsultantComponent } from './pages/ftcconsultant/ftcconsultant.component';
import { FtcsdmruComponent } from './pages/ftcsdmru/ftcsdmru.component';
import { FtcprogrammanagerComponent } from './pages/ftcprogrammanager/ftcprogrammanager.component';
import { FtcregionalmanagerComponent } from './pages/ftcregionalmanager/ftcregionalmanager.component';
import { DataanalystitComponent } from './pages/dataanalystit/dataanalystit.component';
import { ConsultantgeneralComponent } from './pages/consultantgeneral/consultantgeneral.component';

import { NewassociateComponent } from './pages/newassociate/newassociate.component';
import { ConsultantiisComponent } from './pages/consultantiis/consultantiis.component';
import { ConsultantpmumgnfComponent } from './pages/consultantpmumgnf/consultantpmumgnf.component';
import { ContwritedgtComponent } from './pages/contwritedgt/contwritedgt.component';
import { AssociatechennaiComponent } from './pages/associatechennai/associatechennai.component';
import { AssociatechennaiceilComponent } from './pages/associatechennaiceil/associatechennaiceil.component';
import { JvccbtComponent } from './pages/jvccbt/jvccbt.component';
import { AcadamicconsultComponent } from './pages/acadamicconsult/acadamicconsult.component';
import { NotificationComponent } from './pages/notification/notification.component';
import { MotiongraphicdesignerComponent } from './pages/motiongraphicdesigner/motiongraphicdesigner.component';
import { SankalpConsultantComponent } from './sankalp-consultant/sankalp-consultant.component';
import { Seniorconsultant2Component } from './seniorconsultant2/seniorconsultant2.component';

import { JuniorjcsankalpComponent } from './pages/juniorjcsankalp/juniorjcsankalp.component';
import { LegalexpertComponent } from './pages/legalexpert/legalexpert.component';
import { DynmicvacancyComponent } from './pages/dynmicvacancy/dynmicvacancy.component';
import { Conultant01Component } from './pages/conultant01/conultant01.component';
import { Jcconultant02Component } from './pages/jcconultant02/jcconultant02.component';
import { Srconsultant03Component } from './pages/srconsultant03/srconsultant03.component';
import { Consultant04Component } from './pages/consultant04/consultant04.component';
import { Consultantsdmru05Component } from './pages/consultantsdmru05/consultantsdmru05.component';
import { Asssankalp06Component } from './pages/asssankalp06/asssankalp06.component';
import { Jrcongeneral07Component } from './pages/jrcongeneral07/jrcongeneral07.component';
import { Jrdevloper08Component } from './pages/jrdevloper08/jrdevloper08.component';
import { Fullstkdevloper09Component } from './pages/fullstkdevloper09/fullstkdevloper09.component';
import { JrtestengComponent } from './pages/jrtesteng/jrtesteng.component';
import { Mobileappdevop11Component } from './pages/mobileappdevop11/mobileappdevop11.component';
import { Consultant12Component } from './pages/consultant12/consultant12.component';
import { Srconsultant13Component } from './pages/srconsultant13/srconsultant13.component';
import { SankalpconsultantComponent } from './sankalpconsultant/sankalpconsultant.component';
import { Seniorconsultant1Component } from './seniorconsultant1/seniorconsultant1.component';
import { ProjectmanagerComponent } from './projectmanager/projectmanager.component';
import { Dataanalytics1Component } from './pages/dataanalytics1/dataanalytics1.component';
import { SeniorpfsdComponent } from './pages/seniorpfsd/seniorpfsd.component';
import { SenpfsdComponent } from './pages/senpfsd/senpfsd.component';
import { DataarcComponent } from './pages/dataarc/dataarc.component';
import { ProgrammerssComponent } from './pages/programmerss/programmerss.component';
import { ConsulComponent } from './pages/consul/consul.component';
import { FullsdapiComponent } from './pages/fullsdapi/fullsdapi.component';
import { Programmerss1Component } from './pages/programmerss1/programmerss1.component';
import { Senpfsd1Component } from './pages/senpfsd1/senpfsd1.component';
import { ProgrammersssComponent } from './pages/programmersss/programmersss.component';
import { Consultant03Component } from './pages/consultant03/consultant03.component';
import { Consultantquest03Component } from './pages/consultantquest03/consultantquest03.component';
import { Consultantdev03Component } from './pages/consultantdev03/consultantdev03.component';
import { Juniorconsultant03Component } from './pages/juniorconsultant03/juniorconsultant03.component';
import { Consultant0317Component } from './pages/consultant0317/consultant0317.component';
import { Seniorconsultant03Component } from './pages/seniorconsultant03/seniorconsultant03.component';
import { MulticonsComponent } from './pages/multicons/multicons.component';
import { ArdevelopComponent } from './pages/ardevelop/ardevelop.component';
import { AnimatorComponent } from './pages/animator/animator.component';
import { EditorComponent } from './pages/editor/editor.component';
import { SeniorfullComponent } from './pages/seniorfull/seniorfull.component';
import { ProssComponent } from './pages/pross/pross.component';
import { DatalystComponent } from './pages/datalyst/datalyst.component';
import { FevidevComponent } from './pages/fevidev/fevidev.component';
import { SaneComponent } from './pages/sane/sane.component';
import { SystemadmComponent } from './pages/systemadm/systemadm.component';
import { JuniorproComponent } from './pages/juniorpro/juniorpro.component';
import { WebmobilComponent } from './pages/webmobil/webmobil.component';
import { AccountcComponent } from './accountc/accountc.component';
import { AccconsComponent } from './pages/acccons/acccons.component';
import { SrconmultiComponent } from './srconmulti/srconmulti.component';
import { ConquestionComponent } from './conquestion/conquestion.component';
import { MultimcoComponent } from './pages/multimco/multimco.component';
import { ConseniorComponent } from './consenior/consenior.component';
import { CoordmultiComponent } from './coordmulti/coordmulti.component';
import { SconsulComponent } from './sconsul/sconsul.component'; 
import { LanguageComponent } from './pages/language/language.component';
import { SeniorrndComponent } from './seniorrnd/seniorrnd.component';
import { SenmcComponent } from './senmc/senmc.component';
import { OfficesecComponent } from './officesec/officesec.component';
import { PhotograpComponent } from './photograp/photograp.component';
import { QuestaiComponent } from './pages/questai/questai.component';
import { SenitComponent } from './senit/senit.component';
import { ConfinaccComponent } from './pages/confinacc/confinacc.component';
import { ConsanpmuComponent } from './pages/consanpmu/consanpmu.component';
import { MultismcComponent } from './pages/multismc/multismc.component';
import { MultidmComponent } from './pages/multidm/multidm.component';
import { MultiysComponent } from './pages/multiys/multiys.component';
import { Juniorcon24Component } from './juniorcon24/juniorcon24.component';
import { ContwriteComponent } from './pages/contwrite/contwrite.component';

const routes: Routes = [
  {
    path: '',
    component: HomeComponent,
    data: {
      title: 'Home'
    }
  },
  {
    path: 'home',
    component: HomeComponent,
    data: {
      title: 'Home'
    }
  },
  {
    path: 'about',
    component: AboutComponent,
    data: {
      title: 'Home'
    }
  },
  {
    path: 'dataanalystit',
    component: DataanalystitComponent,
    data: {
      title: 'dataanalystit'
    }
  },
  {
    path: 'motiongraphicdesigner',
    component: MotiongraphicdesignerComponent,
    data: {
      title: 'motiongraphicdesigner'
    }
  },
  {
    path: 'sankalpconsultant',
    component: SankalpconsultantComponent,
    data: {
      title: 'sankalpconsultant'
    }
  },
  {
    path: 'seniorconsultant1',
    component: Seniorconsultant1Component,
    data: {
      title: 'seniorconsultant1'
    }
  },
  {
    path: 'seniorconsultant2',
    component: Seniorconsultant2Component,
    data: {
      title: 'seniorconsultant2'
    }
  },

  {
    path: 'seniorfull',
    component: SeniorfullComponent,
    data: {
      title: 'seniorfull'
    }
  },

  {
    path: 'srconmulti',
    component: SrconmultiComponent,
    data: {
      title: 'srconmulti'
    }
  },

  {
    path: 'conquestion',
    component: ConquestionComponent,
    data: {
      title: 'conquestion'
    }
  },

  {
    path: 'consenior',
    component: ConseniorComponent,
    data: {
      title: 'consenior'
    }
  },

  {
    path: 'sconsul',
    component:SconsulComponent,
    data:{
      title: 'sconsul'
    }
  },

  {
    path: 'language',
    component:LanguageComponent,
    data:{
      title: 'language'
    }
  },

  {
    path: 'seniorrnd',
    component:SeniorrndComponent,
    data:{
      title: 'seniorrnd'
    }
  },

  {
    path: 'senmc',
    component:SenmcComponent,
    data:{
      title: 'senmc'
    }
  },

  {
    path: 'officesec',
    component:OfficesecComponent,
    data:{
      title: 'officesec'
    }
  },

  {
    path: 'photograp',
    component:PhotograpComponent,
    data:{
      title: 'photograp'
    }
  },

  {
    path: 'questai',
    component:QuestaiComponent,
    data:{
      title: 'questai'
    }
  },

    {
    path: 'senit',
    component:SenitComponent,
    data:{
      title: 'senit'
    }
  },

  {
    path: 'confinacc',
    component:ConfinaccComponent,
    data:{
      title: 'confinacc'
    }
  },

  {
    path: 'consanpmu',
    component: ConsanpmuComponent,
    data: {
      title: 'consanpmu'
    }
  },
  
  {
    path: 'multismc',
    component: MultismcComponent,
    data: {
      title: 'multismc'
    }
  },

  {
    path: 'multidm',
    component: MultidmComponent,
    data: {
      title: 'multidm'
    }
  },

  {
    path: 'multiys',
    component: MultiysComponent,
    data: {
      title: 'multiys'
    }
  },

  {
    path: 'juniorcon24',
    component: Juniorcon24Component,
    data: {
      title: 'juniorcon24'
    }
  },

  {
    path: 'contwrite',
    component: ContwriteComponent,
    data: {
      title: 'contwrite'
    }
  },

  {
    path: 'coordmulti',
    component: CoordmultiComponent,
    data: {
      title: 'coordmulti'
    }
  },

  // import { AccountcComponent } from './accountc/accountc.component';
  // import { AccconsComponent } from './pages/acccons/acccons.component';
  {
    path: 'accountc',
    component: AccountcComponent,
    data: {
      title: 'accountc'
    }
  },
  {
    path: 'acccons',
    component: AccconsComponent,
    data: {
      title: 'acccons'
    }
  },



  {
    path: 'pross',
    component: ProssComponent,
    data: {
      title: 'pross'
    }
  },

  {
    path: 'datalyst',
    component: DatalystComponent,
    data: {
      title: 'datalyst'
    }
  },

  {
    path: 'fevidev',
    component: FevidevComponent,
    data: {
      title: 'fevidev'
    }
  },

  {
    path: 'sane',
    component: SaneComponent,
    data: {
      title: 'sane'
    }
  },

  {
    path: 'systemadm',
    component: SystemadmComponent,
    data: {
      title: 'systemadm'
    }
  },

  {
    path: 'juniorpro',
    component: JuniorproComponent,
    data: {
      title: 'juniorpro'
    }
  },

  {
    path: 'webmobil',
    component: WebmobilComponent,
    data: {
      title: 'webmobil'
    }
  },

  {
    path: 'multimco',
    component: MultimcoComponent,
    data: {
      title: 'multimco'
    }
  },
  
  {
    path: 'multimco',
    component: MulticonsComponent,
    data: {
      title: 'multicons'
    }
  },
 
  {
    path: 'ardevelop',
    component: ArdevelopComponent,
    data: {
      title: 'ardevelop'
    }
  },
  
  {
    path: 'animator',
    component: AnimatorComponent,
    data: {
      title: 'animator'
    }
  },

  {
    path: 'editor',
    component: EditorComponent,
    data: {
      title: 'editor'
    }
  },

  {
    path: 'projectmanager',
    component: ProjectmanagerComponent,
    data: {
      title: 'projectmanager'
    }
  },
 {
    path: 'dataanalytics1',
    component: Dataanalytics1Component,
    data: {
      title: 'dataanalytics1'
    }
  },
  
  {
    path: 'seniorpfsd',
    component: SeniorpfsdComponent,
    data: {
      title: 'seniorpfsd'
    }
  },
  {
    path: 'senpfsd',
    component: SenpfsdComponent,
    data: {
      title: 'senpfsd'
    }
  },
  
  {
    path: 'dataarc',
    component: DataarcComponent,
    data: {
      title: 'dataarc'
    }
  },
  
  {
    path: 'programmerss',
    component: ProgrammerssComponent,
    data: {
      title: 'programmerss'
    }
  },
  
  {
    path: 'consul',
    component: ConsulComponent,
    data: {
      title: 'consul'
    }
  },
  
  {
    path: 'fullsdapi',
    component: FullsdapiComponent,
    data: {
      title: 'fullsdapi'
    }
  },
 
  {
    path: 'programmerss1',
    component: Programmerss1Component,
    data: {
      title: 'programmerss1'
    }
  },
  
  {
    path: 'senpfsd1',
    component: Senpfsd1Component,
    data: {
      title: 'senpfsd1'
    }
  },
  
  {
    path: 'programmersss',
    component: ProgrammersssComponent,
    data: {
      title: 'programmersss'
    }
  },
  
  {
    path: 'consultant03',
    component: Consultant03Component,
    data: {
      title: 'consultant03'
    }
  },
  
  {
    path: 'consultantquest03',
    component: Consultantquest03Component,
    data: {
      title: 'consultantquest03'
    }
  },
  
  {
    path: 'consultantdev03',
    component: Consultantdev03Component,
    data: {
      title: 'consultantdev03'
    }
  },
  
  {
    path: 'juniorconsultant03',
    component: Juniorconsultant03Component,
    data: {
      title: 'juniorconsultant03'
    }
  },
  
  {
    path: 'seniorconsultant03',
    component: Seniorconsultant03Component,
    data: {
      title: 'seniorconsultant03'
    }
  },
  {
    path: 'consultant0317',
    component: Consultant0317Component,
    data: {
      title: 'consultant0317'
    }
  },
  {
    path: 'contact',
    component: ContactComponent,
    data: {
      title: 'Home'
    }
  },
  {
    path: 'vacancy',
    component: VaccancyComponent,
    data: {
      title: 'Home'
    }
  },
  {
    path: 'consultantgeneral',
    component: ConsultantgeneralComponent,
    data: {
      title: 'consultantgeneral'
    }
  },
  {
    path: 'jconsultant',
    component: JuniorconsultantComponent,
    data: {
      title: 'Home'
    }
  },
  {
    path: 'contentwriter',
    component: ContentwriterComponent,
    data: {
      title: 'Home'
    }
  },
  {
    path: 'engagingconult',
    component: EngagingconultComponent,
    data: {
      title: 'Home'
    }
  },
  {
    path: 'jvc',
    component: VocationalComponent,
    data: {
      title: 'Home'
    }
  },
  {
    path: 'Prgrmmanager',
    component: PrgrmmanagerComponent,
    data: {
      title: 'Home'
    }
  },
  {
    path: 'engagingtech',
    component: EngagingtechComponent,
    data: {
      title: 'Home'
    }
  },
  {
    path: 'login',
    component: LoginComponent,
    data: {
      title: 'Home'
    }
  },
  {
    path: 'register',
    component: RegisterComponent,
    data: {
      title: 'Home'
    }
  },
  {
    path: 'seniorconsultant',
    component: SeniorconsultComponent,
    data: {
      title: 'Home'
    }
  },
  {
    path: 'iisconsultant',
    component: IisconsultComponent,
    data: {
      title: 'Home'
    }
  },
  {
    path: 'consultsankalp',
    component: ConsultsankalpComponent,
    data: {
      title: 'Home'
    }
  },
  {
    path: 'associatesankalp',
    component: AssociatesankalpComponent,
    data: {
      title: 'Home'
    }
  },
  {
    path: 'Ftcsenior',
    component: FtcseniorComponent,
    data: {
      title: 'Home'
    }
  },
  {
    path: 'Ftccounseller',
    component: FtccounsellerComponent,
    data: {
      title: 'Home'
    }
  },
  {
    path: 'Ftclegal',
    component: FtclegalComponent,
    data: {
      title: 'Home'
    }
  },
  {
    path: 'Ftcconsultant',
    component: FtcconsultantComponent,
    data: {
      title: 'Home'
    }
  },
  {
    path: 'Ftcsdmru',
    component: FtcsdmruComponent,
    data: {
      title: 'Home'
    }
  },
  {
    path: 'Ftcprogrammanager',
    component: FtcprogrammanagerComponent,
    data: {
      title: 'Home'
    }
  },
  {
    path: 'Ftcregionalmanager',
    component: FtcregionalmanagerComponent,
    data: {
      title: 'Home'
    }
  },
  {
    path: 'Newassociate',
    component: NewassociateComponent,
    data: {
      title: 'Home'
    }
  },

  {
    path: 'Consultantiis',
    component: ConsultantiisComponent,
    data: {
      title: 'Home'
    }
  },


  {
    path: 'Consultantpmumgnf',
    component: ConsultantpmumgnfComponent,
    data: {
      title: 'Home'
    }
  },

  {
    path: 'ContentWriterdgt',
    component: ContwritedgtComponent,
    data: {
      title: 'Home'
    }
  },
  {
    path: 'sankalp-consultant',
    component: SankalpConsultantComponent,
    data: {
      title: 'sankalp_consultant'
    }
  },
  

  {
    path: 'associateChennai',
    component: AssociatechennaiComponent,
    data: {
      title: 'Home'
    }
  },
  {
    path: 'associateCell',
    component: AssociatechennaiceilComponent,
    data: {
      title: 'Home'
    }
  },

  {
    //path: 'vacncyfulldetail/:id/:id1', component: DynmicvacancyComponent,
    path: 'vacncyfulldetail/:id', component: DynmicvacancyComponent,
  },




  

  // {
  //   path: 'pmu',
  //   component: PmuComponent,
  //   data: {
  //     title: 'Home'
  //   }
  // },
  {
    path: 'otrform',
    component: OtrformComponent,
    data: {
      title: 'Home'
    }
  },
  {
    path: 'testOtr',
    component: TestotrComponent,
    data: {
      title: 'Home'
    }
  },
  {
    path: 'testLogin',
    component: TestloginComponent,
    data: {
      title: 'Home'
    }
  },
  {
    path: 'testReg',
    component: TestRegComponent,
    data: {
      title: 'Home'
    },
    canActivate: [AuthenticationGuard]
  },
  {
    path: 'testDashboard',
    component: TestdashboardComponent,
    data: {
      title: 'Home'
    },
    canActivate: [AuthenticationGuard]
  },
  {
    path: 'testeditreg',
    component: TesteditregComponent,
    data: {
      title: 'Home'
    },
    canActivate: [AuthenticationGuard]
  },
  {
    path: 'jvc-cbt',
    component: JvccbtComponent
  },
  {
    path: 'consultantAcademics',
    component: AcadamicconsultComponent
  },
  {
    path: 'notification',
    component: NotificationComponent
  },
  {   
    path: 'jrJCconsult',
    component: JuniorjcsankalpComponent
  },
  {   
    path: 'legalexpert',
    component: LegalexpertComponent
  },
  {
    path: 'JuniorConsultantDevelopment02',
    component: Jcconultant02Component
  },
  {
    path: 'ConsultantDevelopment01',
    component: Conultant01Component
  },
  {
    path: 'Srconsultant03',
    component: Srconsultant03Component
  },
  {
    path: 'consultant04',
    component: Consultant04Component
  },
  {
    path: 'consultantSDMRU05',
    component: Consultantsdmru05Component
  },
  {
    path: 'associatesankalp06',
    component: Asssankalp06Component
  },
  {
    path: 'Jrcongeneral07',
    component: Jrcongeneral07Component    
  },
  {
    path: 'Jrdevloper08',
    component: Jrdevloper08Component    
  },
  {
    path: 'Fullstkdevloper09',
    component: Fullstkdevloper09Component    
  },
  {
    path: 'Jrtesteng10',
    component: JrtestengComponent    
  },
  {
    path: 'Mobileappdevop11',
    component: Mobileappdevop11Component        
  },
  {
    path: 'Consultant12',
    component: Consultant12Component        
  },
  {
    path: 'Srconsultant13',
    component: Srconsultant13Component        
  }


  
];


@NgModule({
  imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'top', relativeLinkResolution: 'legacy', useHash: true })],

  exports: [RouterModule]
})
export class AppRoutingModule { }
